export const BANNER_HEIGHT = 128;
export const AUTO_ROTATE_MS = 4000;
export const PAUSE_AFTER_INTERACTION_MS = 10000;
export const SLIDE_DURATION_MS = 400;
